"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProvider = exports.getAppointment = exports.deleteAppointment = void 0;
exports.deleteAppointment = '@service/DELETE_APPOINTMENT';
exports.getAppointment = '@service/GET_APPOINTMENT';
exports.getProvider = '@service/GET_PROVIDER';
//# sourceMappingURL=Services.js.map